<template>
  <ProjectScaffold>
    <div class="header">
      <div class="titles">
        <div class="title">Feedback</div>
        <ts-divider></ts-divider>
        <div class="subtitle">
          Can you please give us your rating of this project :<br>
        </div>
        <div>
          <star-rating v-model="form.rating" star-size="30" active-color="#99ffd1" :show-rating="false"></star-rating>
        </div>
        <div class="subtitle mt-6">
          Feel free to add a quick comment to your rating :<br>
        </div>
        <div>
          <ts-input type="textarea" :rows="4" v-model.lazy="form.comment"></ts-input>
        </div>
        <div class="subtitle mt-6">
          Who is your commercial point of contact for this project ?<br>
        </div>
        <div>
          <ts-input type="textarea" :rows="4" v-model.lazy="form.sale"></ts-input>
        </div>
      </div>
    </div>
    <ts-button @click="handleSaveClick">Submit</ts-button>
  </ProjectScaffold>
</template>

<style lang="scss" scoped>
.header {
  display: flex;

  .titles {
    flex-grow: 1;
  }

  .title {
    font-family: Roboto;
    font-size: 20px;
    color: #6d7587;
  }

  .subtitle {
    font-family: Roboto;
    font-size: 12px;
    color: #6d7587;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .actions {
    flex-shrink: 0;
    margin-left: 50px;
    display: flex;

    > * {
      margin-left: 10px;
    }
  }
}

.list-actions {
  margin-bottom: 20px;
  display: flex;

  .select {
    flex-grow: 1;

    > * {
      margin-right: 23px;
    }
  }

  .actions {
    > * {
      margin-left: 8px;
    }
  }
}

.list-header {
  font-family: Roboto;
  font-size: 10px;
  color: #9aa5b7;

  display: flex;

  margin-bottom: 10px;

  .name-header {
    margin-left: 48px;
    width: 400px;
  }
}

.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 400px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .users {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}

.vue-star-rating-rating-text {
  display: none;
}
</style>

<script>
import {mapState, mapActions} from 'vuex';

import ProjectScaffold from '../ProjectScaffold.vue';

import projectViewHelpers from '@/mixins/projectViewHelpers';
import StarRating from 'vue-star-rating'
import {listFeedbacksProject, setFeedbackData, patchFeedbackData} from "@/api/workflow";

export default {
  mixins: [projectViewHelpers],
  components: {
    ProjectScaffold,
    StarRating
  },
  data() {
    return {
      loading: false,
      feedbacks: {},
      post: false,
      form: {
        id: '',
        rating: '',
        comment: '',
        sale: '',
        projectId: '',
        userId: ''
      }
    };
  },
  computed: {},
  methods: {
    async handleSaveClick() {
      this.form.projectId = this.$store.state.workflow.currentProjectId;
      this.form.userId = this.currentUser.id;
      if (this.post === false) {
        await setFeedbackData(this.form, this.$store.state.workflow.currentProjectId, this.currentUser.id);
      } else {
        await patchFeedbackData(this.form, this.$store.state.workflow.currentProjectId, this.currentUser.id);
      }
      this.post = true;
      this.feedbacks = await listFeedbacksProject(this.$store.state.workflow.currentProjectId, this.currentUser.id);
      if (this.feedbacks.length > 0) {
        this.form.id = this.feedbacks[0].id;
        this.form.rating = this.feedbacks[0].rating;
        this.form.comment = this.feedbacks[0].comment;
        this.form.sale = this.feedbacks[0].sale;
      }
      this.showInfo(`Feedback sent !`)
    }
  },
  async mounted() {
    this.feedbacks = await listFeedbacksProject(this.$store.state.workflow.currentProjectId, this.currentUser.id);
    if (this.feedbacks.length > 0) {
      this.post = true;
      this.form.id = this.feedbacks[0].id;
      this.form.rating = this.feedbacks[0].rating;
      this.form.comment = this.feedbacks[0].comment;
      this.form.sale = this.feedbacks[0].sale;
    }
  }
};
</script>
